import React from 'react'
import CreatePatientForm from './PatientForm'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'
import _ from 'lodash'
import moment from 'moment'

export default class PatientComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ patient: '', isUpdate: false })
  }

  componentWillMount () {
    if (!_.isEmpty(this.props.params)) {
      // console.log(this.props.params)
      this.setState({ patient: this.props.params.patient, isUpdate: true })
    }
  }

  render () {
    document.title = 'Registrar Paciente - CORE 3.0'
    return (
      <CreatePatientForm patientId={this.state.patient} isUpdate={this.state.isUpdate} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/PatientComponent.js